import React, { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Button, Grid } from '@mui/material';
import { setSuccessNotification } from '../../../actions/notificationAction'
import { Category } from '../../../shared-components'
import { getSerialNumber } from '../../../utils/sharedFunctions'
import { CategoryApi } from "../api/categoryApi";
import { categorySorting } from "../../../config/sortingLabels";
import useListingActions from '../../../hooks/useListingActions'
import useTranslation from '../../../hooks/useTranslation'
import StoreSelect from '../../../components/Shared/StoreSelect';
import { ListingPage, ListTable, ListTableActions } from '../../../shared-components'

const CategoryContainer = (props) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [selectedStore, setSelectedStore] = useState(() => JSON.parse(localStorage.getItem('categorySelectedStore')) || null);

  const handleExtraParameters = () => {
    if (selectedStore) {
      return { store_id: selectedStore.id }
    } else {
      return {}
    }
  }

  const {
    data,
    count,
    page,
    perPage,
    searchTerm,
    setData,
    sortOptionSelected,
    handlerForSearchingAndSortingChange,
    fetchData
  } = useListingActions('categories', CategoryApi.getCategories, 'latest', handleExtraParameters );

  const newCategory = () => {
    history.push(`/admin/categories/new?store_id=${selectedStore.id}`)
  }

  // Delete
  const deleteCategory = async (category) => {
    await CategoryApi.removeCategory(category, category.store_id)
    setData(data.filter(cat => category.id !== cat.id))
    dispatch(setSuccessNotification({ message: t('response_messages.category_deleted_successfully')}))
  }

  const handleStoreChange = (e, value) => {
    setSelectedStore(value)
    localStorage.setItem('categorySelectedStore', JSON.stringify(value))
    fetchData({ page: 1, per_page: perPage, q: searchTerm, sort_by: sortOptionSelected, ...value && {store_id: value.id} }, true)
  }

  const tableContent = categoryTableContent(deleteCategory, data, page, perPage)

  const tableActions = (
    <ListTableActions
      searchTerm={searchTerm}
      searchText={t('labels.search_categories')}
      sortOptionSelected={sortOptionSelected}
      sortOptions={categorySorting}
      translateText={t}
      getData={handlerForSearchingAndSortingChange}
    />
  )

  const buttons = (
    <Grid container justifyContent="flex-end" spacing={1}>
      <Grid item>
        <StoreSelect selectedStore={selectedStore} onChange={handleStoreChange} />
      </Grid>
      {selectedStore && (
      <Grid item>
        <Button
          color="primary"
          variant="contained"
          onClick={() => newCategory(selectedStore.id)}>
          Create Category
        </Button>
      </Grid>
    )}
    </Grid>
  )

  return (
    <ListingPage
      title={t('labels.menu.categories')}
      actions={buttons}
      table={(<ListTable
        tableHeadings={tableContent.tableHeading}
        tableContent={tableContent.tableBody}
        tableActions={tableActions}
        count={count}
        page_no={page}
        onPageChange={(event, pageNo) => handlerForSearchingAndSortingChange('page', pageNo + 1)}
        handleChangeRowsPerPage={(event) => handlerForSearchingAndSortingChange('pageSize', event.target.value)}
        rowsPerPage={perPage}
        rowsControl={true} />
      )} />
  )
}

const categoryTableContent = (deleteCategory, categories=[], page_no, per_page) => {
  const { t } = useTranslation()
  const history = useHistory();
  const handleEdit = (category) => {
    history.push({
      pathname: `/admin/categories/edit/${category.id}`,
      state: { categoryName: category.name },
    });
  };
  const categoryBody = categories.map((category, i) => (
    <Category key={category.id} {...category} deleteCategory={() => deleteCategory(category)} index={getSerialNumber(page_no, per_page, i)} handleEdit={handleEdit}/>
  ));
  return { tableBody: categoryBody, tableHeading: [t('labels.id') , '',t('labels.name') ,t('labels.visible_on_homepage'), t('labels.public'), t('labels.action')] }
}

export default CategoryContainer
